import Typography from '@cobliteam/ui/components/Typography';

interface DataTableCellVehicleProps {
  licensePlate?: string | null;
  brand?: string | null;
  model?: string | null;
  alias?: string | null;
  groupName?: string;
  showGroupName?: boolean;
  showAlias?: boolean;
  icon?: React.ReactNode;
}

const DataTableCellVehicle = ({ brand, model, licensePlate, alias, groupName, showGroupName = true, showAlias = false, icon }: DataTableCellVehicleProps) => {
  const formattedBrand = brand ? `- ${brand}` : '';
  const formattedModel = model ? `- ${model}` : '';
  const formattedLicensePlate = licensePlate ? ` ${licensePlate}` : '';
  const formattedAlias = alias && showAlias ? `${alias}` : '';

  const vehicleLabel = `${formattedLicensePlate} ${formattedBrand} ${formattedModel}`.trim() || '---';

  return (
    <div className='flex flex-col gap-2'>
      <div className='flex items-center gap-2'>
        {icon}
        <Typography title={vehicleLabel} color='secondary' variant='description-title' className='line-clamp-1'>
          {vehicleLabel}
        </Typography>
      </div>
      {showAlias ? (
        <Typography title={alias} color='secondary' variant='caption-default' className='line-clamp-1'>
          {formattedAlias?.trim() ? formattedAlias : '---'}
        </Typography>
      ) : null}
      {showGroupName ? (
        <Typography title={groupName} color='secondary' variant='caption-default' className='line-clamp-1'>
          {groupName || '---'}
        </Typography>
      ) : null}
    </div>
  );
};

export default DataTableCellVehicle;
